import React from "react";
import ResidentTab from "@source/pages/HomePage/homeRouter/residentTab/residentTab";

export const ResidentConsentHistoryPage = () => <ResidentTab initialHistoryTab="consent"/>;
